import { Swiper, EffectFade, Navigation, Pagination } from 'swiper'
import { createTitleTimeline } from '../animations'
import utils from '../utils'
import appUtils from '../app_utils'

Swiper.use([EffectFade])

// https://greensock.com/docs/v3/Installation
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const dataAttrSuffix = 'section-range'
const dataAttr = 'data-' + dataAttrSuffix


class SectionRange {
  constructor(target, args = {index: 0}) {
    this.target = target
    this.$el = $(this.target)

    this.titleTimeline = null
    this.$title = this.$el.find('[data-section-title]')

    this.$content = this.$el.find('[' + dataAttr + '-content]')
    this.contentScrollTrigger = null

    // this.$carousel = this.$el.find('[data-swiper]')
    this.$carousel = this.$el.find('[' + dataAttr + '-swiper]')
    this.$carouselPagination = this.$el.find('[' + dataAttr + '-swiper-pagination]')
    this.carouselInstance = null
    this.carouselSlidesTimelines = []
    this.carouselIniatialTransitionDone  = false
    this.carouselIniatialActiveIndex = 0

    this.$slideCarousels = this.$el.find('[' + dataAttr + '-item-swiper]')
    this.slideCarouselInstances = []
    this.$surfaceSelector = this.$el.find('[' + dataAttr + '-swiper-surface]')

    // this.$setColorRadio = this.$el.find('[data-set-color]')

    this.$bg = this.$el.find('[' + dataAttr + '-bg]')

    this.id = dataAttrSuffix + '-' + args.index
    if(this.$el.attr('id')) {
      this.id = this.$el.attr('id')
    } else {
      this.$el.attr('id', this.id)
    }
    this.init()
  }

  init() {
    this.titleTimeline = createTitleTimeline(this.$title, true)
    /*
    // https://greensock.com/docs/v3/Plugins/ScrollTrigger/static.matchMedia()
    ScrollTrigger.matchMedia({
      // desktop
      "(orientation: landscape)": ()=>{ // "(min-width: 576px)": ()=>{
        this.contentScrollTrigger = ScrollTrigger.create({
          trigger: this.$content,
          start: "top top",
          end: '+=60%',
          pin: true,
          pinSpacing: true, // false to cover the $content
          toggleClass: 'st-active',
        })
        // THIS IS THE KEY! Return a function that'll get called when the breakpoint no longer matches so we can kill() the animation (or whatever)
        return () => {
          //
          //  ScrollTrigger automatically kills all ScrollTriggers created inside the media query function when that media query no longer matches, so you only need a teardown function for things that aren't directly related to ScrollTriggers. The animation that is associated with a particular ScrollTrigger will be killed along with the ScrollTrigger when the media query no longer matches.

          // this.contentScrollTrigger.kill()
        }
      }
    })
    */
    this.contentScrollTrigger = ScrollTrigger.create({
      trigger: this.$content,
      start: "top center",
      end: 'top top',
      onEnter: ({progress, direction, isActive}) => {
        if (!_self.carouselIniatialTransitionDone) {
          _self.target.querySelectorAll('[data-img]').forEach((image, k) => {
            image.classList.add('in-view-once')
          })

          _self.carouselSlidesTimelines[0].play(0)
          _self.carouselIniatialTransitionDone = true
        }
      },
      toggleActions: 'play none none none',
    })

    // this.carouselInstance = this.$carousel.data('carousel-instance').swpInstance
    this.carouselInstance = new Swiper(this.$carousel[0], {
      modules: [Pagination],
      preloadImages: false,
      // allowTouchMove: false,
      pagination: {
        el: this.$carouselPagination[0],
        clickable: true,
        renderBullet: function (index, className) {
          const slide = this.slides[index]
          // https://developer.mozilla.org/en-US/docs/Learn/HTML/Howto/Use_data_attributes
          const label = slide.dataset.slideTitle || (index + 1)
          const color = slide.dataset.slideColor
          return '<span  style="--bg-color: ' + color + ';" class="' + className + '"><span class="label">' + label + '</span></span>';
        },
      },
    })
    if (this.$carousel.attr('data-active-index')) {
      this.carouselIniatialActiveIndex = parseInt(this.$carousel.attr('data-active-index'), 10)
    }
    this.carouselInstance.activeIndex = this.carouselIniatialActiveIndex


    const _self = this
    this.$carousel[0].querySelectorAll('[data-section-range-swiper-item]').forEach((item, i) => {
      const tl = gsap.timeline()
      /*
      tl.call(()=>{
        item.querySelectorAll('[data-img]').forEach((image, k) => {
          image.classList.remove('in-view-once')
        })
      })

      tl.call(()=>{
        item.querySelectorAll('[data-img]').forEach((image, k) => {
          image.classList.add('in-view-once')
        })
      }, [], '+=0.6')
      */
      /*
      tl.from(item.querySelectorAll('[data-img]'), {
        opacity: 0,
        duration: 0.5
      }, '+=0.3')
      */
      item.querySelectorAll('[data-slide-item]').forEach((slideItem, j) => {
        const image = slideItem.querySelector('[data-img]')
        const title = slideItem.querySelector('[data-title]')
        const caption = slideItem.querySelector('[data-caption]')

        /*tl.call(()=>{
          image.classList.add('in-view-once')
        }, [], (j===0) ? '+=0.1' : '-=0.6')*/

        /*
        tl.from(title, {
          x: -50,
          opacity: 0,
          duration: 0.5
        }, (j===0) ? '+=0' : '-=0.2') // '+=0.2'
        */
        /*
        tl.from(caption, {
          y: 50,
          opacity: 0,
          duration: 0.5,
        }, (j===0) ? '+=0' : '-=0.2') //  '-=0.3' '+=0.6'
        */
      })

      tl.pause()
      _self.carouselSlidesTimelines[i] = tl
    })
    this.carouselInstance.on('activeIndexChange', function () { // slideChange
      // const activeSlide = this.el.querySelector('.swiper-slide.swiper-slide-active')
      _self.carouselSlidesTimelines[parseInt(this.activeIndex, 10)].play(0)

      const slide = this.slides[this.activeIndex]
      const color = slide.dataset.slideBgcolor
      if (color) {
        _self.$bg.css('background-color', color)
      }
    })

    /*
    const setColor = function() {
      const index = $(this).attr('data-set-color')
      _self.carouselInstance.slideTo(parseInt(index, 10))
    }
    this.$setColorRadio.on('change', setColor)
    */
    const slide = this.carouselInstance.slides[0]
    const color = slide.dataset.slideBgcolor
    if (color) {
      this.$bg.css('background-color', color)
    }

    this.$slideCarousels.each((index, item) => {
      const instance = new Swiper(item, {
        // nested: true,
        modules: [Pagination],
        preloadImages: false,
        effect: 'slide', // fade effect does not update layout on resize properly! Do not use it with breakpoints
        allowTouchMove: false,
        slidesPerView: 1,
        spaceBetween: 10,
        breakpoints: {
          992: {
            slidesPerView: 3,
            spaceBetween: 20,
          }
        },
        /*
        pagination: {
          el: item.querySelector('.swiper-pagination'),
          clickable: true,
          renderBullet: function (index, className) {
            const slide = this.slides[index]
            // https://developer.mozilla.org/en-US/docs/Learn/HTML/Howto/Use_data_attributes
            const label = slide.dataset.slideTitle || (index + 1)
            return '<span class="' + className + '">' + label + '</span>';
          },
        },
        */
      })
      this.slideCarouselInstances.push(instance)
    })

    //this.$surfaceSelector
    this.$slideCarousels.first().find('[data-title]').each((index, item) => {
      let cssClass = (index === 0) ? 'swiper-pagination-bullet-active' : ''
      this.$surfaceSelector.append('<span data-set-surface="' + index + '" class="swiper-pagination-bullet ' + cssClass + '"><span class="label">' + $(item).text().trim() + '</span></span>')
    })

    this.$setSurfaceButtons = this.$el.find('[data-set-surface]')
    const setSurface = function() {
      _self.$setSurfaceButtons.removeClass('swiper-pagination-bullet-active')
      const index = parseInt($(this).attr('data-set-surface'), 10)
      _self.slideCarouselInstances.forEach((instance, i) => {
        instance.slideTo(index)
      })
      $(this).addClass('swiper-pagination-bullet-active')
    }
    this.$setSurfaceButtons.on('click', setSurface)
  }

  destroy() {
    if (this.titleTimeline) {
      this.titleTimeline.scrollTrigger.kill()
      this.titleTimeline.kill()
    }

    if (this.contentScrollTrigger) {
      this.contentScrollTrigger.kill()
    }

    this.carouselSlidesTimelines.forEach((tl, i) => {
      tk.kill()
    })

    if (this.carouselInstance) {
      this.carouselInstance.destroy()
    }

    if (this.slideCarouselInstances) {
      this.slideCarouselInstances.forEach((instance, i) => {
        instance.destroy()
      })
    }

    // this.$setColorRadio.off('change')
    this.$setSurfaceButtons.off('click')
  }
}

export default {dataAttr: dataAttr, sectionClass: SectionRange}
